import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row q-gutter-sm q-my-sm" }

import { useI18n } from 'vue-i18n'
import { DownloadImageData } from '../models/AllParts'
import FormHeader from './FormHeader.vue'
import RenderPartImage from './inventory/RenderPartImage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormInventoryView',
  props: {
    image: {},
    header: {}
  },
  setup(__props: any) {


const { t } = useI18n({ useScope: 'global' })

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_card, {
    style: {"min-width":"280px"},
    class: "q-pa-md"
  }, {
    default: _withCtx(() => [
      _createVNode(FormHeader, { "header-text": _ctx.header }, null, 8, ["header-text"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
          default: _withCtx(() => [
            _createVNode(RenderPartImage, {
              "image-type": "standard",
              "image-data": _ctx.image
            }, null, 8, ["image-data"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_q_card_actions, {
        align: "right",
        class: "text-primary"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_btn, {
            flat: "",
            label: _unref(t)('form.close')
          }, null, 8, ["label"]), [
            [_directive_close_popup]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})